export const refURLs = {
    local: 'http://localhost:3000',
    preview: 'https://brandnewdaystorage.blob.core.windows.net/brand-new-day-robots-storage-container',
    production: 'https://brandnewdaystorageprd.blob.core.windows.net/brand-new-day-robots-storage-container',
};

export const getRefURL = () => {
    switch (process.env.REACT_APP_ENDPOINT_ENVIRONMENT) {
        case 'LOCAL':
            return refURLs.local;
        case 'PREVIEW':
            return refURLs.preview;
        case 'PRODUCTION':
            return refURLs.production;
        default:
            return process.env.NODE_ENV === 'production' ? refURLs.production : refURLs.preview;
    }
};

